const DRAWER_OPEN = "DRAWER_OPEN";
const DRAWER_CLOSE = "DRAWER_CLOSE";

export { DRAWER_OPEN, DRAWER_CLOSE };
